import makeContext from '../utils/makeContext';
import initialContext from './initialContext';
import useEventTrackerState from './useEventTrackerState';

export const { Context, Provider, useContext, useAppSelector } = makeContext({
  initialContext,
  useState: useEventTrackerState,
});
